import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fenz-document p-4" }
const _hoisted_2 = { class: "fenz-doc-section" }
const _hoisted_3 = { class: "body pt-3" }
const _hoisted_4 = { class: "grid fenz-grid" }
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "grid fenz-grid pt-2" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "fenz-doc-section" }
const _hoisted_10 = { class: "body pt-3" }
const _hoisted_11 = { class: "grid fenz-grid" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = {
  contenteditable: "true",
  class: "input-div p-inputtext"
}
const _hoisted_14 = { class: "grid fenz-grid pt-2" }
const _hoisted_15 = { class: "col-3" }
const _hoisted_16 = {
  contenteditable: "true",
  class: "input-div p-inputtext"
}
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = {
  contenteditable: "true",
  class: "input-div p-inputtext"
}
const _hoisted_19 = { class: "grid fenz-grid pt-2" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = {
  contenteditable: "true",
  class: "input-div p-inputtext"
}
const _hoisted_22 = { class: "fenz-doc-section" }
const _hoisted_23 = { class: "body pt-3" }
const _hoisted_24 = { class: "grid fenz-grid" }
const _hoisted_25 = { class: "col-3" }
const _hoisted_26 = { class: "col-3 flex align-items-center" }
const _hoisted_27 = { class: "fenz-doc-section" }
const _hoisted_28 = { class: "body pt-3" }
const _hoisted_29 = { class: "grid fenz-grid pt-2" }
const _hoisted_30 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_31 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_32 = { class: "grid fenz-grid pt-2" }
const _hoisted_33 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_34 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_35 = { class: "grid fenz-grid pt-2" }
const _hoisted_36 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_37 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_38 = { class: "fenz-doc-section" }
const _hoisted_39 = { class: "body pt-3" }
const _hoisted_40 = { class: "grid fenz-grid pt-2" }
const _hoisted_41 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_42 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_43 = { class: "grid fenz-grid pt-2" }
const _hoisted_44 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_45 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_46 = { class: "grid fenz-grid pt-2" }
const _hoisted_47 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_48 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_49 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_50 = { class: "grid fenz-grid pt-2" }
const _hoisted_51 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_52 = {
  class: "col-fixed",
  style: {"width":"100px"}
}
const _hoisted_53 = { class: "grid fenz-grid pt-2" }
const _hoisted_54 = {
  class: "col-fixed",
  style: {"width":"300px"}
}
const _hoisted_55 = { class: "fenz-doc-section" }
const _hoisted_56 = { class: "p-2" }
const _hoisted_57 = { class: "grid fenz-grid" }
const _hoisted_58 = { class: "grid fenz-grid pt-2" }
const _hoisted_59 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_SignatureModal = _resolveComponent("SignatureModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[68] || (_cache[68] = _createStaticVNode("<div class=\"fenz-doc-section align-items-center\"><div class=\"css-image fenz-logo fenz-logo-size\"><h2 class=\"fenz-title\">EVACUATION REPORT</h2></div></div><div class=\"fenz-doc-section\"><b> Send the completed report to the Fire Information Unit, by email <a href=\"mailto:evacuation@fireandemergency.nz\" class=\"fenz-link\">evacuation@fireandemergency.nz</a> or post to Fire Information Unit, Fire and Emergency New Zealand, PO Box 68444, Victoria Street West, Auckland 1142. </b></div>", 2)),
      _createElementVNode("div", _hoisted_2, [
        _cache[25] || (_cache[25] = _createElementVNode("div", { class: "header" }, [
          _createElementVNode("span", null, "Part A"),
          _createElementVNode("span", { class: "float-right" }, "Building description")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col-3 fenz-field-name" }, " Building name ", -1)),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.propertyData.buildingName), 1),
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col-3 fenz-field-name" }, " Scheme reference ", -1)),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.evacuation.schemeReference), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "col-3 fenz-field-name" }, " Address ", -1)),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.propertyData.streetAddress) + " " + _toDisplayString(_ctx.propertyData.postalAddress) + " " + _toDisplayString(_ctx.propertyData.suburb) + " " + _toDisplayString(_ctx.propertyData.city), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "header" }, [
          _createElementVNode("span", null, "Part B"),
          _createElementVNode("span", { class: "float-right" }, "Contact person details")
        ], -1)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "col-3 fenz-field-name" }, " Contact person's name ", -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.reportContact.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "col-3 fenz-field-name" }, " Phone number ", -1)),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.reportContact.phone), 1)
            ]),
            _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-3 fenz-field-name" }, " Mobile number ", -1)),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.reportContact.mobile), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "col-3 fenz-field-name" }, " Email address ", -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.reportContact.email), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _cache[37] || (_cache[37] = _createElementVNode("div", { class: "header" }, [
          _createElementVNode("span", null, "Part C"),
          _createElementVNode("span", { class: "float-right" }, "Evacuation details")
        ], -1)),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _cache[34] || (_cache[34] = _createElementVNode("div", { class: "col-3 fenz-field-name" }, " Date of evacuation ", -1)),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_Calendar, {
                class: "evac-date-calendar",
                modelValue: _ctx.dateOfEvacuation,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateOfEvacuation) = $event)),
                dateFormat: "d MM yy",
                showButtonBar: true,
                onDateSelect: _ctx.onDateOfEvacuationChange
              }, null, 8, ["modelValue", "onDateSelect"]),
              _cache[31] || (_cache[31] = _createElementVNode("div", {
                id: "evacDate",
                contenteditable: "true",
                class: "evac-date-div input-div p-inputtext"
              }, null, -1))
            ]),
            _cache[35] || (_cache[35] = _createElementVNode("div", { class: "col-3 fenz-field-name" }, " Time of evacuation ", -1)),
            _createElementVNode("div", _hoisted_26, [
              _cache[32] || (_cache[32] = _createElementVNode("div", {
                contenteditable: "true",
                class: "input-div p-inputtext mr-2"
              }, null, -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["mr-1 p-1", [_ctx.evacTimeAM ? 'circled':'']]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.evacTimeAM = !_ctx.evacTimeAM;_ctx.evacTimePM=false})
              }, " am ", 2),
              _cache[33] || (_cache[33] = _createTextVNode(" / ", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["ml-1 p-1", [_ctx.evacTimePM ? 'circled':'']]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.evacTimePM = !_ctx.evacTimePM;_ctx.evacTimeAM=false})
              }, " pm ", 2)
            ])
          ]),
          _cache[36] || (_cache[36] = _createStaticVNode("<div class=\"grid fenz-grid pt-2\"><div class=\"col-3 fenz-field-name\"> Time taken to evacuate </div><div class=\"col flex align-items-center\"><div contenteditable=\"true\" class=\"input-div p-inputtext mr-2\"></div> minutes <div contenteditable=\"true\" class=\"input-div p-inputtext mr-2 ml-2\"></div> seconds </div></div>", 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "header" }, [
          _createElementVNode("span", null, "Part D"),
          _createElementVNode("span", { class: "float-right" }, "Assessment outcomes")
        ], -1)),
        _createElementVNode("div", _hoisted_28, [
          _cache[47] || (_cache[47] = _createStaticVNode("<div class=\"grid fenz-grid\"><div class=\"col-fixed\" style=\"width:30px;\"></div><div class=\"col\"></div><div class=\"col-fixed\" style=\"width:100px;\"><b>Yes</b></div><div class=\"col-fixed\" style=\"width:100px;\"><b>No</b></div><div class=\"col-fixed\" style=\"width:100px;\"><b>N/A</b></div></div>", 1)),
          _createElementVNode("div", _hoisted_29, [
            _cache[38] || (_cache[38] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"30px"}
            }, " 1 ", -1)),
            _cache[39] || (_cache[39] = _createElementVNode("div", { class: "col" }, [
              _createTextVNode(" Did any injuries occur during this trial evacuation? "),
              _createElementVNode("br"),
              _createElementVNode("small", null, "If yes, detail the injuries that occurred during the trial evacuation")
            ], -1)),
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox1Y,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkbox1Y) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox1N,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.checkbox1N) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _cache[40] || (_cache[40] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"100px"}
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_32, [
            _cache[41] || (_cache[41] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"30px"}
            }, " 2 ", -1)),
            _cache[42] || (_cache[42] = _createElementVNode("div", { class: "col" }, [
              _createTextVNode(" Was the evacuation alarm/method of alerting occupants clearly heard in all areas of the building? "),
              _createElementVNode("br"),
              _createElementVNode("small", null, "If no, detail issue and action taken to remedy it")
            ], -1)),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox2Y,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.checkbox2Y) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox2N,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkbox2N) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _cache[43] || (_cache[43] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"100px"}
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_35, [
            _cache[44] || (_cache[44] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"30px"}
            }, " 3 ", -1)),
            _cache[45] || (_cache[45] = _createElementVNode("div", { class: "col" }, [
              _createTextVNode(" Were all exit ways clear? "),
              _createElementVNode("br"),
              _createElementVNode("small", null, "If no, detail issue and action taken to remedy it")
            ], -1)),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox3Y,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkbox3Y) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox3N,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.checkbox3N) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _cache[46] || (_cache[46] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"100px"}
            }, null, -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _cache[64] || (_cache[64] = _createElementVNode("div", { class: "header" }, [
          _createElementVNode("span", null, "Part D, continued"),
          _createElementVNode("span", { class: "float-right" }, "Assessment outcomes")
        ], -1)),
        _createElementVNode("div", _hoisted_39, [
          _cache[63] || (_cache[63] = _createStaticVNode("<div class=\"grid fenz-grid\"><div class=\"col-fixed\" style=\"width:30px;\"></div><div class=\"col\"></div><div class=\"col-fixed\" style=\"width:100px;\"><b>Yes</b></div><div class=\"col-fixed\" style=\"width:100px;\"><b>No</b></div><div class=\"col-fixed\" style=\"width:100px;\"><b>N/A</b></div></div>", 1)),
          _createElementVNode("div", _hoisted_40, [
            _cache[49] || (_cache[49] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"30px"}
            }, " 4 ", -1)),
            _cache[50] || (_cache[50] = _createElementVNode("div", { class: "col" }, [
              _createTextVNode(" Were 'FIRE ACTION NOTICES' in place? "),
              _createElementVNode("br"),
              _createElementVNode("small", null, "If no, detail issue and action taken to remedy it")
            ], -1)),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox4Y,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.checkbox4Y) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox4N,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.checkbox4N) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _cache[51] || (_cache[51] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"100px"}
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_43, [
            _cache[52] || (_cache[52] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"30px"}
            }, " 5 ", -1)),
            _cache[53] || (_cache[53] = _createElementVNode("div", { class: "col" }, [
              _createTextVNode(" Were systems in place to assist anyone who could not self-evacuate and if so, did the systems function? "),
              _createElementVNode("br"),
              _createElementVNode("small", null, "If no, detail issue and action taken to remedy it")
            ], -1)),
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox5Y,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.checkbox5Y) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox5N,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.checkbox5N) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _cache[54] || (_cache[54] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"100px"}
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_46, [
            _cache[55] || (_cache[55] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"30px"}
            }, " 6 ", -1)),
            _cache[56] || (_cache[56] = _createElementVNode("div", { class: "col" }, [
              _createTextVNode(" Did any equipment to assist with the evacuation work as intended? "),
              _createElementVNode("br"),
              _createElementVNode("small", null, "If no, detail issue and action taken to remedy it")
            ], -1)),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox6Y,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.checkbox6Y) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox6N,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.checkbox6N) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox6NA,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.checkbox6NA) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _cache[57] || (_cache[57] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"30px"}
            }, " 7 ", -1)),
            _cache[58] || (_cache[58] = _createElementVNode("div", { class: "col" }, [
              _createTextVNode(" Occupants accounted for or building determined to be clear in accordance with the evacuation scheme? "),
              _createElementVNode("br"),
              _createElementVNode("small", null, "If no, detail issue and action taken to remedy it")
            ], -1)),
            _createElementVNode("div", _hoisted_51, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox7Y,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.checkbox7Y) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.checkbox7N,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.checkbox7N) = $event)),
                binary: true
              }, null, 8, ["modelValue"])
            ]),
            _cache[59] || (_cache[59] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"100px"}
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_53, [
            _cache[61] || (_cache[61] = _createElementVNode("div", {
              class: "col-fixed",
              style: {"width":"30px"}
            }, " 8 ", -1)),
            _cache[62] || (_cache[62] = _createElementVNode("div", { class: "col" }, " When was the last training session for permanent occupants held? ", -1)),
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_component_Calendar, {
                class: "last-training-calendar",
                modelValue: _ctx.lastTrainingDate,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.lastTrainingDate) = $event)),
                dateFormat: "d M yy",
                showButtonBar: true,
                onDateSelect: _ctx.onLastTrainingDateChange
              }, null, 8, ["modelValue", "onDateSelect"]),
              _cache[60] || (_cache[60] = _createElementVNode("div", {
                id: "lastTrainingDate",
                contenteditable: "true",
                class: "input-div p-inputtext"
              }, null, -1))
            ])
          ])
        ])
      ]),
      _cache[69] || (_cache[69] = _createStaticVNode("<div class=\"fenz-doc-section\"><div class=\"header\"><span>Part E</span><span class=\"float-right\">Additional comments</span></div><div class=\"pt-3\"><div contenteditable=\"true\" class=\"p-inputtext fenz-comments\"></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _cache[65] || (_cache[65] = _createElementVNode("div", { class: "col-3 fenz-field-name" }, " Contact person signature ", -1)),
            _createElementVNode("div", {
              class: "col css-image signature-box",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.displaySignatureModal = true)),
              style: _normalizeStyle({ backgroundImage: `url('data:image/png;base64,${_ctx.reportContact.signatureBase64}')` })
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_58, [
            _cache[67] || (_cache[67] = _createElementVNode("div", { class: "col-3 fenz-field-name" }, " Follow up ", -1)),
            _createElementVNode("div", _hoisted_59, [
              _createVNode(_component_Checkbox, {
                modelValue: _ctx.followUpCheckbox,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.followUpCheckbox) = $event)),
                binary: true
              }, null, 8, ["modelValue"]),
              _cache[66] || (_cache[66] = _createTextVNode(" Tick this box if you would like to speak to someone about this trial. ", -1))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_SignatureModal, {
      open: _ctx.displaySignatureModal,
      signatureBase64: _ctx.reportContact.signatureBase64,
      onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.displaySignatureModal=false)),
      onUpdateSignature: _ctx.updateSignature
    }, null, 8, ["open", "signatureBase64", "onUpdateSignature"])
  ], 64))
}